export const DELIVERY_SORTING_DEFAULT = 'default'
export const DELIVERY_SORTING_CREATION_DATE = 'creation_date'
export const DELIVERY_SORTING_END_CLIENT = 'end_client'
export const DELIVERY_SORTING_TITLE = 'title'
export const DELIVERY_SORTING_STATUS = 'status'
